import React from 'react';
import { injectIntl } from 'react-intl';
import Icon from '../../atoms/icons/Icon';
import Paragraph from '../../atoms/paragraphs/Paragraph';
import { Tooltip } from 'react-tooltip';

const PlanInfoCard = ({ intl, ...props }) => {
  const {
    plan,
    cycle,
    current_plan,
    selected_plan,
    inSummary = false,
    className = '',
    onClick,
  } = props;

  const selectedPlan = selected_plan ? 'plan-selected' : '';

  return (
    <>
      <div
        data-testid={`plan-card-${plan?.id || 'empty'}`}
        className={`${className} d-flex plan-info-card ${selectedPlan ? selectedPlan : ''} ${plan?.empty ? 'empty' : ''} ${plan?.disabled || (plan && plan[cycle + '_disabled']) ? 'disabled' : ''} ${inSummary ? 'summary' : ''} ${plan.current_plan ? 'current-plan ' : ''}`}
        onClick={() => onClick()}
        data-tooltip-id={
          !inSummary && (plan?.disabled || (plan && plan[cycle + '_disabled']))
            ? 'disabledPlan_' + plan.id
            : ''
        }
        data-tooltip-delay-hide={250}
      >
        <div className='plan-info-card-inner-wrapper d-flex flex-column justify-content-center align-items-center position-relative'>
          {(!plan?.empty && (
            <>
              {(current_plan && (
                <div className='current-plan-label'>
                  <Paragraph className='text-paragraph bold text-primary'>
                    {intl.messages['currentPlanFlag']}
                  </Paragraph>
                </div>
              )) || <></>}
              <div>
                <Paragraph className='text-header h3 text-black'>
                  {plan?.name}
                </Paragraph>
              </div>
              <div className='document-limit d-flex flex-row justify-content-between align-items-center my-3'>
                <Icon className='fas fa-circle-check color-brand-primary'></Icon>
                <Paragraph className='text-paragraph bold ms-2 me-1'>
                  {plan?.documents}
                </Paragraph>
                <Paragraph className='text-paragraph bold'>
                  {intl.messages['documentsPerMonth']}
                </Paragraph>
              </div>
              <div className='pricing d-flex flex-row justify-content-between'>
                <Paragraph
                  className={`text-header ${inSummary ? 'h4 text-black' : selectedPlan ? selectedPlan + ' h3' : 'h4 text-black'}`}
                >
                  {(plan && plan[cycle]) || '0'}
                </Paragraph>
                <Paragraph
                  className={`text-header ${inSummary ? 'h4 text-black' : selectedPlan ? selectedPlan + ' h3' : 'h4 text-black'}`}
                >
                  {intl.messages['paymentPerMonth']}
                </Paragraph>
              </div>
              {(((plan && plan[cycle + '_annual_cycle'] !== 0) ||
                (plan &&
                  plan[cycle + '_discount'] &&
                  plan[cycle + '_discount'] !== 0)) && (
                <div className='savings d-flex flex-row justify-content-between mt-3'>
                  {(plan && plan[cycle + '_annual_cycle'] !== 0 && (
                    <Paragraph className='price text-paragraph me-2 my-auto'>
                      {plan && plan[cycle + '_annual_cycle']?.toFixed(2)}
                      {intl.messages['paymentPerYear']}
                    </Paragraph>
                  )) || <></>}
                  {(plan[cycle + '_discount'] &&
                    plan[cycle + '_discount'] !== 0 && (
                      <Paragraph className='saves text-paragraph my-auto'>
                        {intl.messages['saves']}{' '}
                        {plan && plan[cycle + '_discount']?.toFixed(2)}€
                      </Paragraph>
                    )) || <></>}
                </div>
              )) || <></>}

              {inSummary && (
                <div className='summary-cycles-wrapper d-flex justify-content-between mt-1'>
                  <Paragraph className='summary-cycles text-paragraph mb-1'>
                    {intl.messages[`checkoutSummaryCycle_${cycle}`]}
                  </Paragraph>
                </div>
              )}

              <div
                className={`${selectedPlan ? selectedPlan : ''} selected-plan-label mt-3`}
              >
                <Paragraph className='text-paragraph bold'>
                  {intl.messages['chosenPlanFlag']}
                </Paragraph>
              </div>
            </>
          )) || <></>}
        </div>
      </div>

      <Tooltip
        id={`disabledPlan_${plan.id}`}
        className='tooltip'
        content={
          plan && plan[cycle + '_disabled']
            ? intl.messages['disabledPlanTooltipCycle']
            : intl.messages['disabledPlanTooltipDowngrade']
        }
        place='bottom'
      />
    </>
  );
};

export default injectIntl(PlanInfoCard);
